export const ticketsStatus = {
    ACTIVE: 'ACTIVE',
    CLOSED: 'CLOSED',
    PROCESSING: 'PROCESSING',
}
export const ticketsTypes = {
    SERVICE: 'SERVICE',
    COMPLAIN: 'COMPLAIN',
    OTHER: 'OTHER',
}